import React from 'react';
import { Link } from 'react-router-dom';

interface CustomLinkProps {
  link?: string;
  isReactLink?: boolean;
  [x: string]: any;
}

const CustomLink: React.FC<CustomLinkProps> = ({
  link,
  isReactLink = false,
  children,
  ...props
}) => {
  return isReactLink ? (
    <Link to={link} {...props}>
      {children}
    </Link>
  ) : (
    <a href={link} {...props}>
      {children}
    </a>
  );
};

export default CustomLink;
